<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 17 / 14"
    viewBox="0 0 14 17"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M15.817 6.222H.643C.288 6.222 0 6.57 0 7c0 .43.288.778.643.778h15.174c.355 0 .643-.348.643-.778 0-.43-.288-.778-.643-.778z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M15.817 0H.643C.288 0 0 .348 0 .778c0 .43.288.778.643.778h15.174c.355 0 .643-.349.643-.778 0-.43-.288-.778-.643-.778z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M15.817 12.444H.643c-.355 0-.643.349-.643.778 0 .43.288.778.643.778h15.174c.355 0 .643-.348.643-.778 0-.43-.288-.778-.643-.778z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 14,
    },
  },
};
</script>
